import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useRef } from 'react';
import { Stack, Typography } from '@emburse/embark-core';
import { useDialog } from '../components/Dialog';
import { loadingOverlayContext } from '../providers/LoadingOverlayProvider';
import { $t, useTranslation } from './useTranslation';
const useLoadingOverlay = () => {
    useTranslation();
    const { openState, modalState, backdropMessageState } = useContext(loadingOverlayContext);
    const { enqueueDialog, removeDialog } = useDialog();
    const [open, setOpen] = openState;
    const [modalOpen, setModalOpen] = modalState;
    const [, setBackdropMessage] = backdropMessageState;
    const modalTimeout = useRef(null);
    const localApplyLoadingState = useRef((timeout = 15000, newMessage, backdropMessage) => {
        if (open) {
            return;
        }
        const message = newMessage || 'This request is taking longer than usual.';
        if (backdropMessage) {
            setBackdropMessage(backdropMessage);
        }
        setOpen(true);
        const openModal = () => {
            setModalOpen(true);
            const timeoutDialog = {
                title: $t('Confirmation'),
                show: true,
                hideBackdrop: true,
                confirmText: $t('Yes'),
                cancelText: $t('No'),
                onConfirm: () => {
                    setModalOpen(false);
                    modalTimeout.current = setTimeout(openModal, timeout);
                },
                onClose: () => {
                    setOpen(false);
                    setModalOpen(false);
                },
                content: (_jsxs(Stack, { alignItems: "flex-start", children: [_jsx(Typography, { children: $t(message) }), _jsx(Typography, { children: $t('Do you want to continue waiting?') })] }))
            };
            enqueueDialog(timeoutDialog);
        };
        modalTimeout.current = setTimeout(() => {
            if (!modalOpen) {
                openModal();
            }
        }, timeout);
    });
    const localRemoveLoadingState = useRef(() => {
        removeDialog();
        setOpen(false);
        setModalOpen(false);
        clearTimeout(modalTimeout.current);
    });
    const applyLoadingState = window.applyLoadingState || localApplyLoadingState.current;
    const removeLoadingState = window.removeLoadingState || localRemoveLoadingState.current;
    return {
        applyLoadingState,
        removeLoadingState
    };
};
export default useLoadingOverlay;
